import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactPaginate from 'react-paginate';
import ClipLoader from "react-spinners/ClipLoader";

import Api from '../../lib/seam-api';

import Service from './service';

import moment from 'moment';

const NoResults = ({ value = '' }) => {
    return (
        <div className="w-full h-[400px] flex justify-center items-center">
            <div className="flex flex-col gap-[10px] items-center justify-center">
                <img src="/assets/index/no-results.svg" className="h-[150px] mb-4" aria-label="No Results Image"/>
                <h2 class="leading-tight text-2xl font-extrabold text-gray-900 dark:text-white">No results found</h2>
                <p class="mb-4 font-normal text-base text-gray-500 dark:text-gray-400">We couldnt find any matches for <b>{ value }</b></p>
            </div>
        </div>
    )
}

class ServiceSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search : '',
            items : [],
            page: 1,
            pageCount : 0,
            cdnUrl : '/images',
            direction : 'desc',
            order: 'published',
            loading: false,
            isTyping: false,
        };

        this.timeout = null;

        this.searchCanceler = null;
    }

    onChangeHandler({target: { value }}) {
        this.setState({
            search : value,
        }, () => {
            this.changed();
        });
    }

    componentDidMount() {
        const queryParameters = new URLSearchParams(window.location.search);
        const term = queryParameters.get('term');

        if (term) {
            return this.setState({ search: term }, () => this.changed());
        }

        this.changed();
    }

    changed() {
        if(this.state.search.length >= 1) {
            return this.search();
        }

        this.fetchItems();
    }

    search() {
        this.setState({ loading: true })

        if(this.searchTimeOut) {
            clearTimeout(this.searchTimeOut);

        }
        if(this.searchCanceler !== null) {
            this.searchCanceler.cancel('Cancel Content Search');
            this.searchCanceler = null;
        }

        this.searchTimeOut = setTimeout(() => {
            Api.content().search(this.state.search, [ this.props.contentTypeId ], [], searchCanceler => {
                this.searchCanceler = searchCanceler;
            }).then(response => {
                this.setState({
                    items : response.data,
                    pageCount : 0,
                    page : 1,
                    cdnUrl : response.meta.cdn_url,
                    loading: false,
                })
            });
        }, 200);

    }

    fetchItems(page = this.state.page) {
        this.setState({ loading: true })

        Api.content().list(page, 10, [ this.props.contentTypeId ], [], this.state.order, this.state.direction).then(response => {
            this.setState({
                items : response.data,
                pageCount : response.meta.last_page,
                cdnUrl : response.meta.cdn_url,
                loading: false,
            });
        })
    }

    handlePageClick(event) {
        this.setState({ page: event.selected + 1 }, () => this.fetchItems());

    }

    truncateDescription (input) {
        return input?.length > 65 ? `${input.substring(0, 65)}...` : input;
    }

    onOrder(event) {
        this.setState({ order: event.target.value }, () => {
            this.changed();
        })
    }

    onDirection(event) {
        this.setState({ direction: event.target.value }, () => {
            this.changed();
        })
    }
    

    renderFilters() {
        const renderOtherFilters = () => {
            // if (this.props.contentTypeSlug === 'service/grants') {
            //     return (
            //         <div class="flex gap-2">
                      
            //         </div>
            //     )
            // }

            return null;
        }

        return (
            <div className="flex flex-row justify-between flex-wrap gap-4">
                <div class="relative w-[400px]">
                    <input type="search" 
                        id="Service Search Search Bar"
                        class="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50  md:rounded-l-none border-l-1 md:border-l-6 border border-gray-300"
                        placeholder="Search anything..." required onChange={this.onChangeHandler.bind(this)} value={this.state.search}/>
                    <button type="submit"
                        aria-label="Search Button"
                        class="h-[41.48px] w-[41.48px] flex justify-center items-center absolute top-0 right-0 p-2.5 text-sm font-medium text-white bg-primary-700 rounded-r-lg border border-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
                            { this.state.loading ?  <ClipLoader
                                color={'white'}
                                loading={true}
                                size={17}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            /> : <svg
                            class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                        </svg> }</button>
                </div>

                <div className="flex flex-row gap-4 flex-wrap">
                    { renderOtherFilters() }

                    <select onChange={this.onOrder.bind(this)} class="w-[200px] bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        <option value='published' selected>Published (Date)</option>
                        <option value='title'>Title (Alphabetical)</option>
                    </select>

                    <select onChange={this.onDirection.bind(this)} class="w-[200px] bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        <option value='asc'>Ascending</option>
                        <option value='desc' selected>Descending</option>
                    </select>
                </div>
            </div>
        )
    }

    render () {
        return (
            <div className="flex flex-col gap-16 py-8 px-4 mx-auto max-w-screen-xl">
                { this.renderFilters() }

                <div class="py-8 lg:py-16">
                     { this.state.items?.length > 0 ? <div class="grid gap-12 sm:grid-cols-2 sm:gap-16 lg:gap-24 lg:grid-cols-3 xl:grid-cols-3">
                        { this.state?.items?.map(item => <Service item={item} cdnUrl={this.state.cdnUrl} contentTypeSlug={this.props.contentTypeSlug}/>) }
                    </div> : !this.state.loading && <NoResults value={this.state.search}/> }
                </div>

                { this.state.items?.length > 0 && <div class="flex justify-center w-full px-4 mx-auto max-w-screen-xl">
                    <ReactPaginate
                        breakLabel="..."
                        onPageChange={this.handlePageClick.bind(this)}
                        pageRangeDisplayed={5}
                        pageCount={this.state.pageCount}
                        nextLabel={
                            <>
                                <span class="sr-only">Previous</span>
                                <svg aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
                            </>
                        }
                        previousLabel={
                            <>
                                <span class="sr-only">Next</span>
                                <svg aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>
                            </>
                        }
                        renderOnZeroPageCount={null}
                        containerClassName="pagination"
                    />
                </div> }
            </div>
        )
    }
}

export default ServiceSearch;

document.addEventListener('readystatechange', () => {
    const element = document.getElementById('service-search')

    if (element) {
        ReactDOM.render(<ServiceSearch contentTypeId={element.getAttribute('contentTypeId')} contentTypeSlug={element.getAttribute('contentTypeSlug')}/>, element);
    }
});